import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true;

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, 
  timeout: 20000, 
  headers: {
    'Content-Type': 'application/json',
    // Add any custom headers you want
  },
});

// Request interceptor to add token if found
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify the request config before sending it (e.g., add auth token)
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Optional: Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Handle the response before returning it
    return response;
  },
  (error) => {
    const specificEndpoints = ['/auth/account/'];
    const requestURL = error.response?.config?.url;
    
    // Handle errors globally
    if (error.response && error.response.status === 401 &&   
        specificEndpoints.some((endpoint) => requestURL?.includes(endpoint))) {
      localStorage.removeItem('token')
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
